module.exports = __webpack_public_path__ + "img/join_img2.9368c992.jpg";